import React from 'react';
import { Form, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { columnName, columnRole } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import FormValidationError from '@/components/errors/FormValidationError';
import TableWrapper from '@/components/table/TableWrapper';
import UsersTableRows from '@/users/containers/UsersTableRows';
import UsersTableColumns from '@/users/containers/UsersTableColumns';
import RolesDropdown from './RolesDropdown';
import { toggleRoleSelected, updateUsersRole } from '../actions';

const RoleReassignUsersTable = ({
  code,
  updateStatus,
  users,
  reassignUsers,
  selectRole,
}) => (
  <>
    <Form
      autoComplete="off"
      onSubmit={reassignUsers}
    >
      <FormValidationError
        htmlFor="search_code"
        labelId="users.role.reassign.label"
      >
        <RolesDropdown
          category="reassign"
          value={code}
          disabled={updateStatus === states.PENDING}
          onChange={(e, { value }) => selectRole(value, 'reassign')}
          withDescription
          withPermissions
          fluid
          placeholder="users.role.reassign.text"
        />
      </FormValidationError>
    </Form>
    <div className="aridhia-reassign-users-table">
      <TableWrapper sticky celled>
        <Table.Header fullWidth>
          <UsersTableColumns items={users} columns={[columnName, columnRole]} />
        </Table.Header>
        <Table.Body>
          <UsersTableRows items={users} columns={[columnName, columnRole]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </>
);

const mapStateToProps = ({
  roles: {
    roles,
  },
}) => {
  const items = findSelectedInCategory(roles, 'reassign');
  return ({
    users: roles.reassign.users,
    updateStatus: roles.reassign.updateStatus,
    code: items.length > 0 ? items[0].code : null,
  });
};

const mapDispatchToProps = {
  reassignUsers: updateUsersRole,
  selectRole: toggleRoleSelected,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleReassignUsersTable);
